import type { OwaDate } from 'owa-datetime';
import type { DateRange } from 'owa-datetime-utils';

export interface EmptyDateMessage {
    __type: 'EmptyDateMessage';
    text: string;
}

export function buildListWithDates<T>(
    dateRanges: DateRange[],
    getItems: (dateRange: DateRange) => T[],
    emptyDateMessage: string
): Array<T | OwaDate | EmptyDateMessage> {
    const listItems = [];
    if (dateRanges.length > 0) {
        dateRanges.forEach(dateRange => {
            const dateItems = getItems(dateRange);
            listItems.push(dateRange.start);
            if (dateItems.length === 0) {
                listItems.push({ __type: 'EmptyDateMessage', text: emptyDateMessage });
            } else {
                listItems.push(...dateItems);
            }
        });
    }
    return listItems;
}

export function getNearestDateAbove<T>(
    dateList: Array<T | OwaDate | EmptyDateMessage>,
    currentIndex: number
): OwaDate | null {
    for (let index = currentIndex; index >= 0; index--) {
        const top = dateList[index];
        if (top && isOwaDate(top)) {
            return top;
        }
    }
    return null;
}

export function isOwaDate(item: any): item is OwaDate {
    return !!item.tz;
}

export function isEmptyDateMessage(item: any): item is EmptyDateMessage {
    return item.__type === 'EmptyDateMessage';
}
